export function throwIllegalState(message: string): never {
	throw IllegalState(message)
}

export function IllegalState(message: string): Error {
	return Error(`Illegal State: ${message}`)
}
